var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "11px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mask") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.0421687,12.8955823 C13.5080321,12.8955823 13.0301205,13.1064257 12.6646586,13.436747 L7.65361446,10.5200803 C7.68875502,10.3584337 7.71686747,10.1967871 7.71686747,10.0281124 C7.71686747,9.85943775 7.68875502,9.69779116 7.65361446,9.53614458 L12.6084337,6.64759036 C12.9879518,6.99899598 13.4869478,7.21686747 14.0421687,7.21686747 C15.2088353,7.21686747 16.1506024,6.2751004 16.1506024,5.10843373 C16.1506024,3.94176707 15.2088353,3 14.0421687,3 C12.875502,3 11.9337349,3.94176707 11.9337349,5.10843373 C11.9337349,5.27710843 11.9618474,5.43875502 11.996988,5.60040161 L7.04216867,8.48895582 C6.6626506,8.1375502 6.16365462,7.91967871 5.60843373,7.91967871 C4.44176707,7.91967871 3.5,8.86144578 3.5,10.0281124 C3.5,11.1947791 4.44176707,12.1365462 5.60843373,12.1365462 C6.16365462,12.1365462 6.6626506,11.9186747 7.04216867,11.5672691 L12.0461847,14.4909639 C12.0110442,14.6385542 11.9899598,14.7931727 11.9899598,14.9477912 C11.9899598,16.0793173 12.9106426,17 14.0421687,17 C15.1736948,17 16.0943775,16.0793173 16.0943775,14.9477912 C16.0943775,13.8162651 15.1736948,12.8955823 14.0421687,12.8955823 L14.0421687,12.8955823 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Unit/Share",
    transform: "translate(-3.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.e03c81656e9c51ba91652027f8e36eac.svg";
export { ForwardRef as ReactComponent };